const userCardConst = {
  cardType: {
    default: "default",
    user: "user",
    gaming: "gaming",
    masqueradeParty: "masquerade_party",
    livestreaming: "live_streaming",
    coAnchor: "co_anchor",
    privateCallStandby: "private_calls_standby",
  },
  userProfileStatus: {
    normal: "normal",
    live: "live",
    coAnchor: "co-anchor",
    inPrivateBusy: "in-private-busy",
    inPrivateAvailable: "in-private-available",
    videoCall: "video-call",
  },
  routeTo: { profileView: "profile-view", videoCall: "video-call" },
  cardStatus: {
    default: "default",
    live: "live",
    videoCall: "video-call",
  },
  aboutMeReadStatus: {
    upgradeToRead: "upgrade-to-read",
    targetUserNotPremium: "target-user-not-premium",
  },
};

export default userCardConst;
